(function() {
  if (document.body.id !== 'upi') {
    return;
  }

  const expandFAQButton = document.querySelector('#expand-faq-btn');
  const FAQBody = document.querySelector('#upi-faq');
  const FAQCard = document.querySelector('#faq-card');
  const hideFAQButton = document.querySelector('#hide-faq-btn');
  const sticky = document.querySelector('#upi-faq .sticky-bar');

  if (expandFAQButton && FAQBody) {
    expandFAQButton.addEventListener('click', () => {
      FAQBody.classList.add('expanded');
      FAQCard.classList.add('disappear');
      sticky.classList.remove('hidden');
    });
    hideFAQButton.addEventListener('click', () => {
      FAQBody.classList.remove('expanded');
      FAQCard.classList.remove('disappear');
      sticky.classList.add('hidden');
      if (typeof FAQCard.scrollIntoView === 'function') {
        setTimeout(() => {
          FAQCard.scrollIntoView({
            behavior: 'smooth'
          });
        }, 300);
      }
    });
  }

  if (sticky) {
    const startElement = sticky.parentElement || document.body;
    const endElementSelector =
      sticky.getAttribute('data-sticky-end-element') || 'body';
    const endElement = document.querySelector(endElementSelector);
    const TOP_OFFSET = 0;
    const FIXED_TOP_CLASS = 'fixed-top';
    window.addEventListener('scroll', () => {
      const start = startElement.getBoundingClientRect().top;
      const end = endElement.getBoundingClientRect().bottom;
      const stickyHeight = sticky.getBoundingClientRect().height;
      const stickyBottom = end - stickyHeight - TOP_OFFSET;
      if (start <= TOP_OFFSET) {
        sticky.classList.add(FIXED_TOP_CLASS);
      } else {
        sticky.classList.remove(FIXED_TOP_CLASS);
        sticky.style.top = '';
      }
      if (stickyBottom < 0) {
        sticky.style.top = stickyBottom + 'px';
      } else {
        sticky.style.opacity = 1;
        sticky.style.top = '';
      }
    });
  }
})();
